module.exports = __webpack_public_path__ + "images/emoji/runner.f96ea5ae0ceb2e0f8c4d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/runner.png
// module id = SH4a
// module chunks = 14